<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#FFD9C3"
    />
    <path
      d="M21.6667 11.6667H12.3333C11.597 11.6667 11 12.2637 11 13.0001V22.3334C11 23.0698 11.597 23.6667 12.3333 23.6667H21.6667C22.403 23.6667 23 23.0698 23 22.3334V13.0001C23 12.2637 22.403 11.6667 21.6667 11.6667Z"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 15.6667H23"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.6666 10.3333V12.9999"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.3334 10.3333V12.9999"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
